<h1 fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" mat-dialog-title>
	<div>Recent Orders</div>
	<button color="primary" mat-dialog-close mat-icon-button type="button">
		<mat-icon>close</mat-icon>
	</button>
</h1>
<mat-dialog-content>
	<div fxLayout="column" fxLayoutAlign="start">
		<app-search (doSearch)="getRecentOrders($event)" [minSearchLength]="0"></app-search>
		<div *ngIf="dataSource?.data?.length > 0" fxLayoutAlign="end">
			<button [color]="'primary'" [matMenuTriggerFor]="menu"
					mat-button>{{'placeOrderView.showMyLastLabel' | translate}} {{numberOfOrdersToGet}}
			</button>
			<mat-menu #menu="matMenu">
				<button (click)="setNumberOfOrdersToGet(10)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 10
				</button>
				<button (click)="setNumberOfOrdersToGet(50)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 50
				</button>
				<button (click)="setNumberOfOrdersToGet(100)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 100
				</button>
			</mat-menu>
		</div>
		<div *ngIf="dataSource?.data?.length > 0">
			<div class="mat-table-wrapper">
				<mat-table [dataSource]="dataSource">
					<ng-container matColumnDef="origin">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.originColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.originColumnHeader' | translate">
							<div>
								<div>{{element?.origin?.name}}</div>
								<div>{{element?.origin?.address1}}<span
										*ngIf="element?.origin?.address2">, {{element?.origin?.address2}}</span></div>
								<div>{{element?.origin?.city}}, {{element?.origin?.state}} {{element?.origin?.zip}}</div>
							</div>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="destination">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.destinationColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.destinationColumnHeader' | translate">
							<div>
								<div>{{element?.destination?.name}}</div>
								<div>{{element?.destination?.address1}}<span
										*ngIf="element?.destination?.address2">, {{element?.destination?.address2}}</span>
								</div>
								<div>{{element?.destination?.city}}, {{element?.destination?.state}} {{element?.destination?.zip}}</div>
							</div>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="orderType">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.orderTypeColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.orderTypeColumnHeader' | translate">
							{{element?.orderTypeDescription}}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="action">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.actionsColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.actionsColumnHeader' | translate">
							<button [color]="'primary'" [matMenuTriggerFor]="actionMenu" mat-icon-button>
                                <mat-icon *ngIf="!element?.validOrder" 
                                        class="icon-ivalid-order" 
                                        matTooltip="{{'placeOrderView.invalidRecentOrderText' | translate}}" 
                                        matTooltipPosition="left">
                                    report_problem
                                </mat-icon>
                                <mat-icon>
                                    list
                                </mat-icon>
							</button>
							<mat-menu #actionMenu="matMenu">
								<button (click)="closeModal()" *ngIf="user?.inetUser?.allowTrackOrder"
										[routerLink]="['/track-order', {trackingId: element?.id, startDate: element?.readyTimeFrom?.standardizedDate}]"
										mat-menu-item type="button">
									{{'placeOrderView.showTrackingInfoActionText' |
									translate}}
								</button>
								<button (click)="selectOrderAction('edit', element?.id)"
										*ngIf="user?.editOrderValue !== 'NEVER' && element?.isEditable && element?.validOrder"
										mat-menu-item type="button">
									{{'placeOrderView.editOrderActionText' | translate}}
								</button>
								<!--status 4 means cancelled oh yeah!!!!-->
								<button (click)="cancelOrder(element)"
										*ngIf="user?.cancelOrderOption !== 'NEVER' && element?.isCancelable && element?.status !== 4" mat-menu-item type="button">
									{{'placeOrderView.cancelOrderActionText' | translate}}
								</button>
								<button (click)="selectOrderAction('duplicate', element?.id)" *ngIf="element?.validOrder" mat-menu-item
										type="button">
									{{'placeOrderView.createDuplicateOrderActionText' |
									translate}}
								</button>
								<button (click)="selectOrderAction('roundTrip', element?.id)" mat-menu-item
										type="button" *ngIf="element?.validOrder">
									{{'placeOrderView.createRouteTripActionText' | translate}}
								</button>
								<button (click)="selectOrderAction('continuation', element?.id)" mat-menu-item
										type="button" *ngIf="element?.validOrder">
									{{'placeOrderView.createContinuationActionText' | translate}}
								</button>
								<button (click)="selectOrderAction('sameOrigin', element?.id)" mat-menu-item
										type="button" *ngIf="element?.validOrder">
									{{'placeOrderView.createUsingOriginActionText' | translate}}
								</button>
								<button (click)="selectOrderAction('sameDestination', element?.id)" mat-menu-item
										type="button" *ngIf="element?.validOrder">
									{{'placeOrderView.createUsingDestinationActionText' | translate}}
								</button>
								<button (click)="selectOrderAction('addToCart', element?.id)"
										*ngIf="user?.allowCartCheckout === true && element?.validOrder" mat-menu-item type="button">
									{{'placeOrderView.addToCartText' | translate}}
								</button>
							</mat-menu>
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
				</mat-table>
			</div>
		</div>
		<mat-card *ngIf="dataSource?.data?.length === 0" class="warning">
			<mat-card-content>
				<p>No recent orders found</p>
			</mat-card-content>
		</mat-card>
	</div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button>
		<span>Cancel</span>
	</button>
</mat-dialog-actions>
